export default [
  {"field":"traffic", "mode":"sum" },
  {"field":"nonBounces", "mode":"sum" },
  {"field":"distinctUsers", "mode":"sum" },
  {"field":"distinctConvertedUsers", "mode":"sum" },
  {"field":"convertedSessions", "mode":"sum" },
  {"field":"convertedSessionsFP", "mode":"sum" },
  {"field":"convertedSessionsNonFP", "mode":"sum" },
  {"field":"numConversions", "mode":"sum" },
  {"field":"numConversionsFP", "mode":"sum" },
  // {"field":"numConversionsFPNonFP", "mode":"sum" },
  {"field":"numOrders", "mode":"sum" },
  {"field":"numOrdersFP", "mode":"sum" },
  {"field":"numOrdersNonFP", "mode":"sum" },
  {"field":"orderNet", "mode":"sum" },

  {"field":"orderNetFP", "mode":"sum" },
  {"field":"orderNetNonFP", "mode":"sum" },
  {"field":"numDiscounts", "mode":"sum" },
  {"field":"numDiscountsFP", "mode":"sum" },
  {"field":"numDiscountsNonFP", "mode":"sum" },
  {"field":"discount", "mode":"sum" },
  {"field":"discountFP", "mode":"sum" },
  {"field":"discountNonFP", "mode":"sum" },
  {"field":"pageViews", "mode":"sum" },
  {"field":"homePageViews", "mode":"sum" },
  {"field":"categoryPageViews", "mode":"sum" },
  {"field":"productPageViews", "mode":"sum" },
  {"field":"cartPageViews", "mode":"sum" },
  {"field":"timeOnSite", "mode":"sum" },
  {"field":"nonTargeted", "mode":"sum" },
  {"field":"targeted", "mode":"sum" },
  {"field":"targetedWithOffer", "mode":"sum" },
  {"field":"targetedCollected", "mode":"sum" },
  {"field":"widgetViews", "mode":"sum" },
  {"field":"widgetClicks", "mode":"sum" },
  {"field":"uniqueWidgetViews", "mode":"sum" },
  {"field":"uniqueWidgetClicks", "mode":"sum" },

  {"field":"sourceType", "mode":null},
  {"field":"source", "mode":null},
  {"field":"device", "mode":null},
  {"field":"userType", "mode":null},
  {"field":"pageCategoryExtracted", "mode":null},
  // {"field":"orderProductCategory", "mode":null},
  {"field":"orderDiscountCode", "mode":null},

  {"field":"recommendationNetSummary", "alias": "recommendationNet", "mode":"sum", "group":"recommendationSummary"},
  {"field":"recommendationNet", "mode":"sum", "group":"recommendationDetail"},
  {"field":"recommendationViewed", "mode":"sum", "group":"recommendationDetail"},
  {"field":"recommendationClicked", "mode":"sum", "group":"recommendationDetail"},
  {"field":"recommendationAddToCart", "mode":"sum", "group":"recommendationDetail"},
  {"field":"recommendationPurchased", "mode":"sum", "group":"recommendationDetail"},
  // {"field":"attributionCount", "mode":"sum", "group":"attributionDetail"},
  // {"field":"attributionSessionCount", "mode":"sum", "group":"attributionDetail"},

  {"field":"omittedByAb", "mode":null },
  {"field":"endDate", "mode":null },
  {"field":"widgetId", "mode":null, "group":"widgetDetail"},
  {"field":"incentiveId", "mode":null, "group":"offerDetail"},
  {"field":"segmentId", "mode":null, "group":"segmentDetail"},
  {"field":"campaignId", "mode":null, "group":"campaignDetail"},
  {"field":"attributionCategoryId", "mode":null, "group":"attributionDetail"},
  {"field":"attributionDefinitionId", "mode":null, "group":"attributionDetail"},
  {"field":"recommendationModel", "mode":null, "group":"recommendationDetail"},
  // {"field":"siteTraffic", "mode":null }
]